import { FC, useCallback, useState } from "react";
import { Control, useController } from "react-hook-form";

import EquipmentSelectionCheckboxGroup, {
  EquipmentSelectionCheckboxGroupProps,
  SelectedCheckboxValues,
} from "./EquipmentSelectionCheckboxGroup.tsx";

export type ControlledEquipmentSelectionCheckboxGroupProps = Omit<
  EquipmentSelectionCheckboxGroupProps,
  "value" | "onChange"
> & {
  control: Control<any>;
};

const ControlledEquipmentSelectionCheckboxGroup: FC<
  ControlledEquipmentSelectionCheckboxGroupProps
> = ({ control, name, ...props }) => {
  const { field } = useController({
    control,
    name,
  });
  const [value, setValue] = useState<SelectedCheckboxValues[]>(field.value || []);

  const onMultipleChange = useCallback(
    (newValue: SelectedCheckboxValues[]) => {
      field.onChange(newValue);

      setValue(newValue);
    },
    [field],
  );

  return (
    <EquipmentSelectionCheckboxGroup
      name={name}
      value={value}
      onChange={onMultipleChange}
      {...props}
    />
  );
};

export default ControlledEquipmentSelectionCheckboxGroup;
